export default "__VITE_ASSET__CfuTEA_m__"